// extracted by mini-css-extract-plugin
export default {"stageContainer":"update-stage_stageContainer__73uYU","stageLabel":"update-stage_stageLabel__TW+jY"};